export default function TermsOfUse() {
    return <div>TermsOfUse</div>;
}
